"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VLContentScalars;
(function (VLContentScalars) {
    VLContentScalars["VLText"] = "VLText";
    VLContentScalars["VLLongText"] = "VLLongText";
    VLContentScalars["VLDate"] = "VLDate";
    VLContentScalars["VLDateTime"] = "VLDateTime";
    VLContentScalars["VLBoolean"] = "VLBoolean";
    VLContentScalars["VLNumber"] = "VLNumber";
})(VLContentScalars = exports.VLContentScalars || (exports.VLContentScalars = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NhbGFycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jbXMvc2NoZW1hL3NjYWxhcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLGdCQU9YO0FBUEQsV0FBWSxnQkFBZ0I7SUFDMUIscUNBQWlCLENBQUE7SUFDakIsNkNBQXlCLENBQUE7SUFDekIscUNBQWlCLENBQUE7SUFDakIsNkNBQXlCLENBQUE7SUFDekIsMkNBQXVCLENBQUE7SUFDdkIseUNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQVBXLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBTzNCIn0=